function reducer(state = [], action) {

    switch (action.type) {
        case 'MEDALS/SET':
            return action.medals;
        default:
            return state;
    }
}

export default reducer;